/* Sticky Add to Bag for the 2026 PDP (Figma 1174:2).

   Two jobs, and deliberately nothing else:

   1. decide when the bar is on screen
   2. keep it saying exactly what the main buy block says

   The second is the important one. The bar does not work out a label, a price,
   a sold-out state or a pre-order date of its own -- it copies them from the
   button it is standing in for. Anything it derived separately would
   eventually disagree with the real control, and the bar is the copy a shopper
   acts on when the real one is off screen.

   Submitting is not handled here at all: the button carries form="<product
   form id>", so the browser submits the form already on the page and the
   theme's existing product-form element does the rest. */
(function () {
  if (window.EttikaStickyAtc) return;

  var VISIBLE = 'pdp2026-sticky--visible';

  function bar() {
    return document.querySelector('[data-pdp2026-sticky]');
  }
  /* The sticky button carries .pdp2026-atc too -- that is how it inherits the
     surface and hover -- so the main one has to be named by what it is not. */
  function mainButton() {
    return document.querySelector('.pdp2026-atc:not(.pdp2026-atc--sticky)');
  }
  function buyBlock() {
    return document.querySelector('.pdp2026-buy');
  }

  /* ---- what the bar says ---- */

  function syncLabel() {
    var source = document.querySelector('[data-pdp2026-atc-label]');
    var target = document.querySelector('[data-pdp2026-sticky-label]');
    if (!source || !target) return;
    var text = source.textContent.trim();
    if (text && target.textContent.trim() !== text) target.textContent = text;
  }

  /* The price is markup, not a string -- a sale shows a struck figure beside
     the live one -- so clone it rather than reading textContent and guessing
     where the two numbers divide. */
  function syncPrice() {
    var source = document.querySelector('[data-pdp2026-atc-price]');
    var target = document.querySelector('[data-pdp2026-sticky-price]');
    if (!source || !target) return;
    if (target.dataset.from === source.innerHTML) return;
    target.dataset.from = source.innerHTML;
    target.innerHTML = source.innerHTML;
  }

  /* "Tiger's Eye · 18k Gold Plated", and on a ring "Size 7 · 18k Gold Plated"
     (1199:34) -- a size is named, because a bare number beside a material
     reads as part of it. Read from the picker rather than from a variant
     lookup, so a product whose options are driven by the link switchers still
     reads correctly; a row the picker hides is not a choice and is skipped,
     which also keeps "One Size" out of it. */
  function syncVariantLine() {
    var target = document.querySelector('[data-pdp2026-sticky-variant]');
    if (!target) return;

    var sizes = [];
    var rest = [];
    document.querySelectorAll('.pdp2026-option').forEach(function (group) {
      if (group.classList.contains('pdp2026-option--replaced')) return;
      if (group.offsetParent === null) return; // a hidden row is not a choice

      var name = group.dataset.optionName || '';
      var isSize = name === 'Size' || name === 'Length';

      /* A size is only named once one is chosen. Until then the label reads
         "Select", and "Size Select" is not a variant. A row driven by link
         switchers has no inputs and is always a real value. */
      var inputs = group.querySelectorAll('.pdp2026-option__input');
      if (inputs.length && !group.querySelector('.pdp2026-option__input:checked')) return;

      var value = group.querySelector('.pdp2026-option__label-value');
      var text = value && value.textContent.trim();
      if (!text) return;

      if (isSize) {
        text = name + ' ' + text;
        if (sizes.indexOf(text) === -1) sizes.push(text);
        return;
      }
      if (rest.indexOf(text) === -1) rest.push(text);
    });

    // The size leads, as 1199:34 has it.
    var line = sizes.concat(rest).join(' · ');
    if (!line) {
      target.hidden = true;
      return;
    }
    if (target.textContent.trim() !== line) target.textContent = line;
    target.hidden = false;
  }

  /* The ship estimate comes from Globo, through the same resolver the
     recommendation cards use, so the bar and the cards cannot disagree about
     a date. Absent app, absent row. */
  function syncShips() {
    var row = document.querySelector('[data-pdp2026-sticky-ships]');
    if (!row) return;

    var api = window.EttikaPreorderCard;
    var host = bar();
    if (!api || !host) {
      row.hidden = true;
      return;
    }

    var label = api.labelFor(
      host.dataset.productHandle,
      host.dataset.productId,
      host.dataset.variantId
    );
    if (!label) {
      row.hidden = true;
      return;
    }
    row.querySelector('.pdp2026-sticky__ships-text').textContent = label;
    row.hidden = false;
  }

  /* The save tag restates the variant's own discount. Taken from the price the
     main button is showing, so it tracks whatever rule produced it. */
  function syncSave() {
    var tag = document.querySelector('[data-pdp2026-sticky-save]');
    var price = document.querySelector('[data-pdp2026-atc-price]');
    if (!tag || !price) return;

    var was = price.querySelector('.pdp2026-atc__price-was');
    var now = price.querySelector('.pdp2026-atc__price-now');
    if (!was || !now) {
      tag.hidden = true;
      return;
    }

    var amount = money(was) - money(now);
    if (!(amount > 0)) {
      tag.hidden = true;
      return;
    }
    tag.textContent = 'Save ' + format(was.textContent, amount);
    tag.hidden = false;
  }

  /* Money in, number out. The figures are already localised, so the currency
     symbol and separators are whatever the market uses -- strip everything
     that is not a digit or a decimal point rather than assuming a format. */
  function money(el) {
    var text = String(el.textContent || '').replace(/[^0-9.,]/g, '');
    // Last separator with two digits after it is the decimal point, if any.
    var m = text.match(/^(.*)[.,](\d{2})$/);
    if (m) return parseFloat(m[1].replace(/[.,]/g, '') + '.' + m[2]) || 0;
    return parseFloat(text.replace(/[.,]/g, '')) || 0;
  }

  /* Rebuild the saving in the same shape as the figure it came from, so the
     symbol and its placement follow the market rather than being hardcoded. */
  function format(sample, amount) {
    var rounded = amount % 1 === 0 ? String(amount) : amount.toFixed(2);
    return String(sample).replace(/[\d.,]+/, rounded);
  }

  /* The sold-out state belongs to the buy block: there the control is the
     notify form, which the bar cannot stand in for, so it steps aside. Same
     for a product with no add button at all. */
  function shouldExist() {
    var button = mainButton();
    if (!button) return false;
    var block = buyBlock();
    if (block && block.classList.contains('pdp2026-buy--sold-out')) return false;
    return true;
  }

  function sync() {
    var host = bar();
    if (!host) return;
    if (!shouldExist()) {
      hide();
      host.dataset.suppressed = '1';
      return;
    }
    delete host.dataset.suppressed;

    syncLabel();
    syncPrice();
    syncVariantLine();
    syncShips();
    syncSave();

    /* Awaiting a size is not a disabled button -- the main one stays
       clickable and scrolls the shopper to the picker -- so mirror the class
       rather than the disabled attribute. */
    var button = mainButton();
    var target = document.querySelector('[data-pdp2026-sticky-atc]');
    if (button && target) {
      var awaiting = button.classList.contains('pdp2026-atc--awaiting-size');
      target.classList.toggle('pdp2026-atc--awaiting-size', awaiting);
    }
  }

  /* ---- when the bar is on screen ---- */

  function show() {
    var host = bar();
    if (!host || host.dataset.suppressed) return;
    host.classList.add(VISIBLE);
    host.setAttribute('aria-hidden', 'false');
  }

  function hide() {
    var host = bar();
    if (!host) return;
    host.classList.remove(VISIBLE);
    host.setAttribute('aria-hidden', 'true');
  }

  function watchMainButton() {
    var button = mainButton();
    if (!button) return;

    if (typeof IntersectionObserver === 'undefined') {
      show();
      return;
    }

    /* The bar stands in for the main button, so it appears exactly when that
       button leaves. An observer rather than a scroll listener: the 2025 bar
       measured the button on every scroll event, which is work on a page this
       heavy for an answer that changes twice. */
    new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) hide();
          else show();
        });
      },
      { threshold: 0 }
    ).observe(button);
  }

  function start() {
    if (!bar()) return;
    sync();
    watchMainButton();

    /* A variant change rewrites the main button, and Globo answers late. */
    document.addEventListener('change', function (event) {
      if (event.target.matches && event.target.matches('.pdp2026-option__input')) {
        setTimeout(sync, 0);
      }
    });

    var block = buyBlock();
    if (block) {
      new MutationObserver(function () {
        sync();
      }).observe(block, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    }

    /* Globo loads on its own schedule; a bounded re-check costs nothing
       because each pass is a lookup over data already in the page. */
    var waited = 0;
    var timer = setInterval(function () {
      waited += 500;
      syncShips();
      if (waited >= 15000) clearInterval(timer);
    }, 500);
  }

  window.EttikaStickyAtc = { sync: sync, show: show, hide: hide };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
